import React, { useContext } from 'react'

import { Button } from '@components/Button'

import Routes from '@utils/routes'

import { AstuteContext } from '../context'

export const BackToDashboardButton = () => {
  const {
    state: { client },
  } = useContext(AstuteContext)

  return (
    <Button secondary className='button' href={Routes.clientDashboardPath({ clientId: client.id })}>
      Back to client dashboard
    </Button>
  )
}
